<template>
  <p class="breadcrumb">
    <pp-breadcrumb separator="\">
      <pp-breadcrumb-item v-for="route in pathMap" :key="route.id" :href="route.path">{{ route.name }}</pp-breadcrumb-item>
    </pp-breadcrumb>
  </p>
</template>
<script>
/**
 * 面包屑
 * 动态显示当前页的面包屑🍞
 */
export default {
  name: 'Breadcrumb',
  data() {
    return {
      pathMap: []
    }
  },
  computed: {
    matched() {
      return this.$route.matched
    }
  },
  watch: {
    matched() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.pathMap = [
        {
          name: '网站管理',
          path: '/aq/websiteList'
        }
      ]
      const map = []
      // 获取当前页面的route树
      this.matched.forEach((route, index) => {
        if (index > 0) {
          const obj = {
            path: route.path,
            name: ''
          }
          switch (route.path) {
            case '/aq/webDetail':
              obj.name = '网站详情'
              break
            case '/aq/bondDetail':
              obj.name = '网站详情保证金明细'
              break
            case '/aq/tradeDetail':
              obj.name = '交易详情'
              break
          }
          obj.path && map.push(obj)
        }
      })
      this.pathMap = this.pathMap.concat(map)
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumb {
	height: 52px;
	line-height: 52px;
	width: 1190px;
	margin: 0 auto;
}
</style>
